<template>
  <div v-show="companies.length > 1">
    <v-select
      :items="companies"
      :attach="attach"
      v-model="clavedat"
      @input="$emit('input', clavedat)"
      :class="cssClass"
      :label="label"
      item-text="APELNOM"
      item-value="CLAVEDAT"
      :error-messages="error"
    ></v-select>
  </div>
</template>

<script>
export default {
  $_veeValidate: {
    // must not be arrow functions.
    // the name getter
    name() {
      return this.label;
    },
    // the value getter
    value() {
      return this.value; // `this` is the component instance, `value` is the prop we added.
    },
  },
  props: {
    value: {
      type: [Number, String],
    },
    cssClass: {
      type: [Object, String],
    },
    label: {
      type: String,
    },
    error: {
      type: String,
    },
    attach: {
      type: [Boolean, String],
      default: false,
    },
  },
  data() {
    return {
      clavedat: null,
    };
  },
  mounted() {
    if (this.$store.state.clavedat) {
      this.clavedat = this.$store.state.clavedat ? Number(this.$store.state.clavedat) : '';
      this.$emit('input', this.clavedat);
    }
  },
  computed: {
    companies() {
      let result = [];
      if (
        this.$store.state.hasOwnProperty('user') &&
        this.$store.state.user.hasOwnProperty('customer_profile') &&
        this.$store.state.user.customer_profile &&
        this.$store.state.user.customer_profile.hasOwnProperty('fiscal_data') &&
        this.$store.state.user.customer_profile.fiscal_data &&
        Array.isArray(this.$store.state.user.customer_profile.fiscal_data)
      ) {
        result = this.$store.state.user.customer_profile.fiscal_data;
      }
      return result;
    },
  },
  methods: {},
};
</script>

<style></style>
